import Vue from "vue";

/**
 * Class Profile Service
 */
export default class TermService extends Vue {
    
    private customActions = {
        acceptTerm: { method: 'POST', url: 'auth/term/accept-term' },
        termToAccept: { method: 'GET', url: 'auth/term/term-to-accept/{id_user}' },
    };
    
    private resource: any = this.$resource('auth/term', {}, this.customActions);

    public async get() {
        return this.resource.get();
    }

    public async termToAccept(id_user: number) {
        return this.resource.termToAccept({ id_user }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public acceptTerm(param) {
        return this.resource.acceptTerm(param).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }
}